import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  .date {
    font-size: 14px;
  }
`;

export const FiltersContainer = styled.div`
  display: grid;
  gap: 16px;

  grid-template-columns: 1fr 1fr 200px 1fr;

  align-items: end;

`;

export const Row = styled.tr <{ status?: Number }> `
  td {
    font-weight: ${({ status }) => status ? 600 : 400};
  }

  color: ${({ theme, status }) => status === 5
    ? theme.colors.attention
    : status === 7
      ? theme.colors.succesful : ''
  };
`;

export const Td = styled.td`

  `;
